import interceptor from '@/plugins/interceptor';
const preInscriptionPath = '/PreInscriptions';
const certificatePath = '/Certificate';
const stuffPath = '/Stuff';
const coursesPath = '/CoursesInstances';
const learningUserPath = "/LearningUsers";

export default {
    actions: {
        async preInscription_getPreInscription(_,id) {
            return await interceptor.authenticate.get(`${process.env.VUE_APP_API_LMS_INSCRIPTION_URL}${preInscriptionPath}/${id}`);
        },
        async preInscription_getPreInscriptionResume(_,id) {
            return await interceptor.authenticate.get(`${process.env.VUE_APP_API_LMS_INSCRIPTION_URL}${preInscriptionPath}/${id}/resume`);
        },
        async preInscription_getCourseTypeOptions() {
            return await interceptor.authenticate.get(`${process.env.VUE_APP_API_LMS_ADMIN_URL}${stuffPath}/courseType`);
        },
        async preInscription_postPreInscription(_,model) {
            return await interceptor.authenticate.post(`${process.env.VUE_APP_API_LMS_INSCRIPTION_URL}${preInscriptionPath}`,model);
        },
        async preInscription_editPreInscription(_, params) {
            return await interceptor.authenticate.put(`${process.env.VUE_APP_API_LMS_INSCRIPTION_URL}${preInscriptionPath}/PreInscription/${params.id}`, params.data);
        },
        async preInscription_getCreationOptions() {
            return await interceptor.authenticate.get(`${process.env.VUE_APP_API_LMS_INSCRIPTION_URL}${stuffPath}/creationOptions`);
        },
        async preInscription_getPreInscriptionCourseCfgCertificateInfo(_, courseCfgId) {
            return await interceptor.authenticate.get(`${process.env.VUE_APP_API_LMS_INSCRIPTION_URL}${stuffPath}/${courseCfgId}/certificateInfo`);
        },
        async preInscription_getPreInscriptionSettings(_, params) {
            const { preInscriptionId, stage=0 } = params
            return await interceptor.authenticate.get(`${process.env.VUE_APP_API_LMS_INSCRIPTION_URL}${preInscriptionPath}/${preInscriptionId}/settings?stage=${stage}`);
        },
        async preInscription_postPreInscriptionStage(_, req) {
            return await interceptor.authenticate.post(`${process.env.VUE_APP_API_LMS_INSCRIPTION_URL}${preInscriptionPath}/${req.preInscriptionId}/students`, req);
        },
        // async preInscription_checkEmailExists(_, email) {
        //     return await interceptor.authenticate.get(`${process.env.VUE_APP_API_LMS_INSCRIPTION_URL}${preInscriptionPath}/users/${email}`);
        // },
        // new GET inscriptionapi/api/v1/PreInscriptions/{preinscriptionId}/users/{userEmail}
        async preInscription_checkEmailExists(_, params) {
            return await interceptor.authenticate.get(`${process.env.VUE_APP_API_LMS_INSCRIPTION_URL}${preInscriptionPath}/${params.preInscriptionId}/users/${params.userEmail}`);
        },
        async preInscription_studentCheck(_, params) {
            const { preInscriptionId } = params
            return await interceptor.authenticate.get(`${process.env.VUE_APP_API_LMS_INSCRIPTION_URL}${preInscriptionPath}/${preInscriptionId}/students?${params.GUID ? 'studentIdentifier=' + params.GUID : 'studentEmail=' + params.email}`);
        },
        async preInscription_getPreinscriptions(_, params) {
            return await interceptor.authenticate.get(`${process.env.VUE_APP_API_LMS_INSCRIPTION_URL}${preInscriptionPath}?pageNumber=${params.page}&rowsPerPage=${params.rows}&status=${params.status}&forgeUserId=${params.forgeUserId}&country=${params.country}&courseType=${params.courseType}&targetType=${params.targetType}`);
        },
        async preInscription_changeStatus(_, id) {
            return await interceptor.authenticate.put(`${process.env.VUE_APP_API_LMS_INSCRIPTION_URL}${preInscriptionPath}/${id}`);
        },
        async preInscription_getExcel(_, params) {
            return await interceptor.authenticate.getFile(`${process.env.VUE_APP_API_LMS_INSCRIPTION_URL}${preInscriptionPath}/${params.id}/excel`,params.fileName);
        },
        async preInscription_getCertificateTemplates(_, params) {
            return await interceptor.authenticate.get(`${process.env.VUE_APP_API_LMS_ADMIN_URL}${certificatePath}/templates?pageNumber=${params.pageNumber}&rowsPerPage=${params.rowsPerPage}`);  
        },
        async preInscription_getCertificateLayouts(_, params) {
            return await interceptor.authenticate.get(`${process.env.VUE_APP_API_LMS_ADMIN_URL}${certificatePath}/layouts?pageNumber=${params.pageNumber}&rowsPerPage=${params.rowsPerPage}`);
        },
        async preInscription_checkCertificateTemplateName(_, params) {
            return await interceptor.authenticate.post(`${process.env.VUE_APP_API_LMS_ADMIN_URL}${certificatePath}/templates/name`, params);
        },
        async preInscription_createCertificateTemplate(_, params) {
            return await interceptor.authenticate.post(`${process.env.VUE_APP_API_LMS_ADMIN_URL}${certificatePath}/templates`, params);  
        },
        //CoursesInstances
        async coursesInstances_courseAmount(_, model) {
            return await interceptor.authenticate.put(`${process.env.VUE_APP_API_LMS_ADMIN_URL}${coursesPath}/courseAmount`, model);
        },
        async coursesInstances_schedule(_, model) {
            return await interceptor.authenticate.put(`${process.env.VUE_APP_API_LMS_ADMIN_URL}${coursesPath}/schedule`, model);
        },
        async coursesInstances_getCourses(_, params) {
            return await interceptor.authenticate.get(
              `${process.env.VUE_APP_API_LMS_ADMIN_URL}${coursesPath}?pageNumber=${params.page}&rowsPerPage=${params.rows}&statusFilter=${params.status}&forgeUserId=${params.forgeUserId}&country=${params.country}&courseCfgId=${params.courseCfgId}&courseType=${params.courseType}&targetType=${params.targetType}`
            );
        },
        async coursesInstances_modifyEndDate(_, body) {
            return await interceptor.authenticate.put(`${process.env.VUE_APP_API_LMS_ADMIN_URL}${coursesPath}/${body.courseId}/endDate`, { endDate: body.endDate });
        },            
        async coursesInstances_createCourses(_, model) {
            return await interceptor.authenticate.post(`${process.env.VUE_APP_API_LMS_ADMIN_URL}${coursesPath}`, model);
        },
        async coursesInstances_addStudent(_, body) {
            console.log(body)
            const { courseId } = body
            return await interceptor.authenticate.post(
              `${process.env.VUE_APP_API_LMS_ADMIN_URL}${coursesPath}/${courseId}/students`,
              body
            );
        },
        async coursesInstances_addUser(_, body) {
            console.log(body)
            const { courseId } = body
            const { data } = body
            return await interceptor.authenticate.post(
              `${process.env.VUE_APP_API_LMS_ADMIN_URL}${coursesPath}/${courseId}/forgeUsers`,
              data
            );
        },
        async coursesInstances_students(_, body) {
            const { courseId, page, status, search, canCertificate } = body;
            return await interceptor.authenticate.get(
              `${process.env.VUE_APP_API_LMS_ADMIN_URL}${coursesPath}/${courseId}/students?pageNumber=${page}&rowsPerPage=5&statusFilter=${status}&filter=${search}&canCertificate=${canCertificate}`
            );
        },
        async coursesInstances_users(_, body) {
            const { courseId } = body;
            return await interceptor.authenticate.get(
              `${process.env.VUE_APP_API_LMS_ADMIN_URL}${coursesPath}/${courseId}/forgeUsers`
            );
        },
        async coursesInstances_certificate(_, body) {
            const { courseId, learningUserId } = body;
            return await interceptor.authenticate.post(
              `${process.env.VUE_APP_API_LMS_ADMIN_URL}${coursesPath}/${courseId}/students/${learningUserId}/canCertificate`
            );
        },
        async coursesInstances_uncertificate(_, body) {
            const { courseId, learningUserId } = body;
            return await interceptor.authenticate.put(
              `${process.env.VUE_APP_API_LMS_ADMIN_URL}${coursesPath}/${courseId}/students/${learningUserId}/Uncertificate`
            );
        },
        async coursesInstances_deleteUser(_, body) {
            const { courseId, forgeUserId } = body;
            return await interceptor.authenticate.delete(
              `${process.env.VUE_APP_API_LMS_ADMIN_URL}${coursesPath}/${courseId}/forgeUsers/${forgeUserId}`
            );
        },
        async coursesInstances_alterState(_, body) {
            const { courseId, learningUserId } = body;
            return await interceptor.authenticate.put(
              `${process.env.VUE_APP_API_LMS_ADMIN_URL}${coursesPath}/${courseId}/students/${learningUserId}/alterState`
            );
        },
        async coursesInstances_alterEmail(_, body) {
            const { learningUserId } = body;
            return await interceptor.authenticate.put(
                `${process.env.VUE_APP_API_LMS_ADMIN_URL}${learningUserPath}/${learningUserId}/email`,
                body
            );
        },
        async coursesInstances_changePhone(_, body) {
            const { learningUserId } = body;
            return await interceptor.authenticate.put(
                `${process.env.VUE_APP_API_LMS_ADMIN_URL}${learningUserPath}/${learningUserId}/phone`,
                body
            );
        },
        async coursesInstances_getRelatedCoursesOptions(_, sourceId) {
            return await interceptor.authenticate.get(`${process.env.VUE_APP_API_LMS_ADMIN_URL}${coursesPath}/${sourceId}/relationship/options`);
        },
        async coursesInstances_addRelatedCourse(_, body) {
            const { sourceId, destinationId } = body;
            return await interceptor.authenticate.post(`${process.env.VUE_APP_API_LMS_ADMIN_URL}${coursesPath}/${sourceId}/relationship/${destinationId}`);
        },
        async coursesInstances_removeRelatedCourse(_, body) {
            const { sourceId, destinationId } = body;
            return await interceptor.authenticate.delete(`${process.env.VUE_APP_API_LMS_ADMIN_URL}${coursesPath}/${sourceId}/relationship/${destinationId}`);
        }
    }
}
